
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropDownListModule } from '../custom-drop-down-list/custom-drop-down-list.module';
import { CustomButtonModule } from '../custom-button/custom-button.module';
import { CustomInputModule } from '../custom-input/custom-input.module';
import { DynamicFormComponent } from './dynamic-form.component';
import { DynamicFieldDirective } from './dynamic-field.directive';
import { CustomSwitchModule } from '../custom-switch/custom-switch.module';
import { CustomCheckboxModule } from '../custom-checkbox/custom-checkbox.module';
import { CustomTextAreaModule } from '../custom-text-area/custom-text-area.module';
import { CustomDividerModule } from '../custom-divider/custom-divider.module';
import { CustomDatePickerModule } from '../custom-date-picker/custom-date-picker.module';
import { CustomTitleModule } from '../custom-title/custom-title.module';
import { CustomRadioButtonModule } from '../custom-radio-button/custom-radio-button.module';
import { CustomItemSelectorModule } from '../custom-item-selector/custom-item-selector.module';
import { CustomOverlayMessaggeModule } from "../custom-overlay-messagge/custom-overlay-messagge.module";




@NgModule({
  declarations: [
    DynamicFormComponent,
    DynamicFieldDirective,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropDownListModule,  
    CustomButtonModule,
    CustomInputModule,
    CustomSwitchModule,
    CustomCheckboxModule,
    CustomTextAreaModule,
    CustomDividerModule,
    CustomDatePickerModule,
    CustomTitleModule,
    CustomRadioButtonModule,
    CustomItemSelectorModule,
    CustomOverlayMessaggeModule
  ],
  exports: [DynamicFormComponent]
})
export class DynamicFormModule { }
